<template>
  <v-card elevation="2">
    <v-card-title class="card-title-style"
      >{{ expansionHeader }}
      <div class="ml-auto d-flex flex-row">
        <v-tooltip v-if="!isChildProposal" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-btn color="blue" @click="calculate" icon>
                <v-icon>mdi-calculator</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Calculate child proposals</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-btn
                @click="
                  $router.push(`/proposals/${$route.params.id}/pricing-plans`)
                "
                icon
              >
                <v-icon color="green">mdi-pencil-plus</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Open pricing plans detail page</span>
        </v-tooltip>
        <div class="button-group" style="display: inline-flex;">
          <v-tooltip v-if="!isChildProposal" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" style="display: inline-block; margin: 0; padding: 0;">
                <v-btn 
                  color="blue" 
                  @click="autoFill()" 
                  icon
                  class="main-button"
                >
                  <v-icon>mdi-auto-download</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Autofill pricing plans</span>
          </v-tooltip>
          <v-menu offset-y v-if="!isChildProposal">
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <div v-bind="attrs" v-on="{ ...tooltip, ...menu }" style="display: inline-block; margin: 0; padding: 0;">
                    <v-btn
                      color="blue"
                      icon
                      class="dropdown-button"
                    >
                      <v-icon>mdi-menu-down</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Select template</span>
              </v-tooltip>
            </template>
          <v-list>
            <v-list-item @click="autoFill('startups_three_level')">
              <v-list-item-title>Startups Three Level</v-list-item-title>
            </v-list-item>
            <v-list-item @click="autoFill('outstaff_outsource')">
              <v-list-item-title>Outstaff & Outsource</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        </div>
        <v-tooltip v-if="!isChildProposal" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="ml-3">
              <v-switch
                v-model="isEnabled"
                :true-value="true"
                :false-value="false"
                :loading="isLoading"
                :disabled="isLoading"
                color="blue"
              ></v-switch>
            </div>
          </template>
          <span>{{ isEnabled ? 'Disable pricing plans' : 'Enable pricing plans' }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-text style="width: 100%; height: 10vh;" class="d-flex justify-center align-center px-0 py-0" v-if="isLoading">
      <v-progress-circular
        class="mx-auto"
        :size="30"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-card-text>
    <v-card-text class=" black--text px-0 pb-0" v-if="isEmptyObj && !isLoading">
      <div
        v-for="({ id, name, isParentProposal, childProposalId, proposalId, totalHours, totalPrice }, index) in expansionPanelContent"
        :key="id"
        :class="index % 2 === 0 ? '' : 'card-text-bg'"
        class="px-3"
      >
        <div class="d-flex flex-row">
          <div class="pa-4">
            <div class="item-title-font">{{ name }}
              <span v-if="(childProposalId || proposalId) === proposalRouteId" class="ml-2 proposal-mark current">CURRENT</span>
              <span v-if="isParentProposal" class="ml-2 proposal-mark parent">PARENT</span>
            </div>
            <div class="item-description-font">
              {{ totalHours != null && totalHours >= 0 ? totalHours + "hrs" : '' }}
              {{ totalPrice != null && totalPrice >= 0 ? totalPrice.toFixed(2) + "$" : '' }}
            </div>
          </div>
          <div v-if="(childProposalId || proposalId) !== proposalRouteId" class="ml-auto my-auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-btn
                    class="color-blue"
                    style="cursor: pointer"
                    @mouseover="showByIndex = index"
                    @mouseout="showByIndex = null"
                    @click="viewPricingPlan(id, childProposalId, proposalId)"
                    icon
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>View</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-text class="black--text mt-5 pl-7" v-else-if="!isEmptyObj && !isLoading">
      <div class="red--text">No data found!</div>
      <div class="item-description-font">
        Try to add pricing plan, or use autofill.
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import axiosInstance from "@/axios";
import _ from "lodash";

export default {
  data: () => ({
    expansionHeader: "Pricing plans",
    isLoading: false,
    showByIndex: null,
  }),
  computed: {
    isChildProposal() {
      return this.$store.state.isChildProposal;
    },
    isEmptyObj: function() {
      if (this.expansionPanelContent) {
        let isEmpty = _.isEmpty(this.expansionPanelContent);
        return !isEmpty;
      }
      return null;
    },
    expansionPanelContent: function() {
      return this.$store.state.pricingPlans;
    },
    proposalRouteId() {
      return Number(this.$route.params.id);
    },
    isEnabled: {
      get() {
        return this.$store.state.settings.enableProposalPackages;
      },
      set(value) {
        this.toggleEnable(value);
      },
    },
  },
  methods: {
    viewPricingPlan(id, childProposalId, proposalId) {
      this.setAnchourPoint(`a-${id}`);
      const routeId = childProposalId || proposalId;
      this.$router.push(`/proposals/${routeId}`);
    },
    async toggleEnable(value) {
      if (typeof value !== 'boolean') return;

      this.isLoading = true;
      try {
        await axiosInstance.put(
          `/proposal/${this.proposalRouteId}/settings/packages/${value}`,
        );

        this.$store.commit("setEnablePricingPlans", value);
        await this.refreshProposalData();
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async autoFill(template) {
      this.isLoading = true;
      try {
        let url = `/proposal/${this.proposalRouteId}/package/auto`;

        if (template) {
          url += `?template=${template}`;
        }

        await axiosInstance.post(url);
        await this.refreshProposalData();
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async calculate() {
      this.isLoading = true;
      try {
        await axiosInstance.post(
          `/proposal/${this.proposalRouteId}/package/sync`
        );

        await this.refreshProposalData();
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async refreshProposalData() {
      await this.$store.dispatch("getCurrentProposalData", this.proposalRouteId);
      await this.$store.dispatch("getSummaryData", this.proposalRouteId);
    },
    // TESTME
    setAnchourPoint(anchour) {
      this.$store.commit("setAnchour", anchour);
    },
  },
};
</script>

<style scoped>
.card-title-style {
  min-height: 82px;
}
.block-title {
  display: inline-block;
}
.proposal-mark {
  padding: 0px 6px;
  background: rgb(76, 175, 80) !important;
  border-radius: 4px;
  color: #FFFFFF !important;
  letter-spacing: 0.5px;
}
.current {
  background: rgb(76, 175, 80) !important;
}
.parent {
  background: rgb(33, 150, 243) !important;
}
.main-button {
  border: 1px solid rgb(33, 150, 243) !important;
  /* border-right: none !important; */
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  margin-right: 0 !important;
}
.dropdown-button {
  border: 1px solid rgb(33, 150, 243) !important;
  border-left: none !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  margin-left: 0 !important;
}
</style>
